import React from "react";

export const PageBreadCrumbs = () => {
    return (
        <div className="h-12">
            
        </div>
    )
}